import { gql } from 'src/generated/gql';

export const SAVE_POP_IN_CLINIC_SETTINGS = gql(`
  mutation SavePopInClinicSettings($settings: [staff_PopInClinicSettingInput!]!) {
    staff_savePopInClinicSettings(settings: $settings)
  }
`);
